import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import {
  blackColor,
  blackColor27,
  blackShade8,
  orangeColor03,
  whiteColor,
} from "../../configs/styles/muiThemes";

function HeroSection({
  handleGetStarted,
  rellerProfileData,
  businessAffiliateData,
  affiCommissionPercentage,
}) {
  const businessResellerData = businessAffiliateData?.businessResellers?.[0];
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        backgroundImage: "url(/./assets/images/affiliates-banner-2.svg)",
        padding: "20px 15px 36px",
        margin: 0,
        borderRadius: "7px",
        backgroundPosition: "99%",
        backgroundSize: "100% 90%",
        backgroundRepeat: "no-repeat",
        height: "auto",
        position: "relative",
        width: "100%",
        boxSizing: "border-box",
      }}
      // display='flex'
      // alignItems='center'
      // p='12px'
      // sx={{
      //   backgroundImage: 'url(https://storage.googleapis.com/bodefaults/shopweb/affiliates-banner.png)',
      //   backgroundSize: '100% 100%',
      // }}
    >
      <Box px={1}>
        <Typography
          variant="h2"
          fontSize={14}
          fontWeight={600}
          lineHeight="20px"
          color={whiteColor}
          sx={{ m: "8px 0 !important" }}
        >
          Direct Product Promotions, Higher commission than marketplaces
        </Typography>

        <Typography
          variant="body2"
          fontSize={12}
          fontWeight={400}
          lineHeight="18px"
          color={orangeColor03}
          sx={{ m: "8px 0 15px 0 !important" }}
        >
          {/* {businessResellerData?.affiliatePercentage}% commissions on every sale */}
          {affiCommissionPercentage}% commissions on every sale
        </Typography>

        <Button
          variant="contained"
          onClick={handleGetStarted}
          disableElevation
          sx={styles.getStartedBtn}
        >
          {rellerProfileData?.details
            ? "SHARE & EARN - CLICK HERE"
            : "GET STARTED - CLICK HERE"}
        </Button>
      </Box>

      {/* <Box
        component='img'
        src='https://storage.googleapis.com/bodefaults/shopweb/affiliates-banner-image.png'
        sx={{ width: '145px', height: 'auto' }}
      /> */}
    </Box>
    // <Box
    //   display='flex'
    //   alignItems='center'
    //   p='12px'
    //   sx={{
    //     backgroundImage:
    //       'url(https://storage.googleapis.com/bodefaults/shopweb/affiliates-banner.png)',
    //     backgroundSize: '100% 100%',
    //   }}
    // >
    //   <Box>
    //     <Typography
    //       variant='h2'
    //       fontSize={15}
    //       fontWeight={500}
    //       lineHeight='24px'
    //       color={blackColor}
    //       sx={{ m: '10px 0 !important' }}
    //     >
    //       Direct Product Promotions, Higher commission than marketplaces
    //     </Typography>

    //     <Typography
    //       variant='body2'
    //       fontSize={13}
    //       fontWeight={400}
    //       lineHeight='18px'
    //       color={blackColor}
    //       sx={{ m: '8px 0 15px 0 !important' }}
    //     >
    //       {/* {businessResellerData?.affiliatePercentage}% commissions on every sale */}
    //       {affiCommissionPercentage}% commissions on every sale
    //     </Typography>

    //     <Button
    //       variant='contained'
    //       onClick={handleGetStarted}
    //       disableElevation
    //       sx={styles.getStartedBtn}
    //     >
    //       {rellerProfileData?.details
    //         ? 'SHARE & EARN - CLICK HERE'
    //         : 'GET STARTED - CLICK HERE'}
    //     </Button>
    //   </Box>

    //   <Box
    //     component='img'
    //     src='https://storage.googleapis.com/bodefaults/shopweb/affiliates-banner-image.png'
    //     sx={{ width: '145px', height: 'auto' }}
    //   />
    // </Box>
  );
}

export default HeroSection;

const styles = {
  getStartedBtn: {
    padding: "3px 17px",
    position: "relative",
    backgroundColor: whiteColor,
    border: "1px solid " + whiteColor,
    color: blackColor27,
    borderRadius: "50px",
    height: "auto",
    fontSize: "11px",
    textTransform: "uppercase",
    fontWeight: "600",
    lineHeight: "20px",

    "&:hover": {
      color: whiteColor,
      backgroundColor: blackColor,
      textDecoration: "none",
    },
  },
};
